import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

export const unix = (): number => {
	const utcNow = dayjs.utc();
	return utcNow.unix();
};
